<div class="home-container" *ngIf="showPortalContent">
    <!-- Hero Section -->
    <div class="hero-section">
        <div class="hero-content">
            <div class="welcome-message">
                    <h1 class="welcome-title">
                     <i class="pi pi-home text-white mr-3"></i>
                     Bienvenido, {{currentUser.name ?? currentUser.email ?? 'Usuario'}}
                     <span class="user-role-inline" *ngIf="currentUser">
                         <p-tag [value]="getUserRoleDisplay()" 
                                [severity]="getRoleSeverity()" 
                                class="user-role-tag">
                         </p-tag>
                     </span>
                 </h1>
                <p class="welcome-subtitle">
                    Sistema de Gestión de Seguridad y Salud en el Trabajo
                </p>
            </div>
        </div>
    </div>

    <!-- Quick Actions Section -->
    <div class="quick-actions-section">
        <div class="section-header">
                         <h2 class="section-title">
                 <i class="pi pi-bolt text-primary mr-2"></i>
                 Acciones Rápidas
             </h2>
            <p class="section-description">Accede rápidamente a las funciones más utilizadas</p>
        </div>

        <div class="quick-actions-grid">
            <!-- EPP Request - Primary Action -->
            <div class="action-card primary-action" (click)="router.navigate(['epp/request/create/home'])">
                <div class="card-main-content">
                    <div class="card-icon">
                        <i class="pi pi-pen-to-square"></i>
                    </div>
                    <div class="card-content">
                        <h3 class="card-title">Solicitar EPP</h3>
                        <p class="card-description">Crea una nueva solicitud de Equipos de Protección Personal</p>
                        <div class="card-features">
                            <span class="feature-tag">
                                <i class="pi pi-check-circle text-success mr-1"></i>
                                Proceso guiado
                            </span>
                            <span class="feature-tag">
                                <i class="pi pi-clock text-info mr-1"></i>
                                Rápido y fácil
                </span>
                        </div>
                    </div>
                </div>
                <div class="card-arrow">
                    <i class="pi pi-arrow-right"></i>
                </div>
            </div>

            <!-- My Requests - User Only -->
            <div class="action-card" (click)="router.navigate(['epp/request/my-requests'])" *ngIf="isUser()">
                <div class="card-main-content">
                    <div class="card-icon">
                        <i class="pi pi-th-large"></i>
                    </div>
                    <div class="card-content">
                        <h3 class="card-title">Mis Solicitudes</h3>
                        <p class="card-description">Revisa el estado de tus solicitudes de EPP</p>
                        <div class="card-features">
                                                 <span class="feature-tag">
                             <i class="pi pi-eye text-primary mr-1"></i>
                             Seguimiento en tiempo real
                </span>
                        </div>
                    </div>
                </div>
                <div class="card-arrow">
                    <i class="pi pi-arrow-right"></i>
                </div>
            </div>
        </div>
    </div>

    <!-- Admin Functions Section -->
    <div class="admin-section" *ngIf="isAdmin()">
        <div class="section-header">
            <h2 class="section-title">
                <i class="pi pi-shield text-warning mr-2"></i>
                Gestión de EPP
            </h2>
            <p class="section-description">Gestiona solicitudes y procesos de Epp</p>
        </div>
        <div class="admin-grid">
            <!-- Review Requests -->
            <div class="admin-card" (click)="router.navigate(['epp/request/list'])">
                <div class="card-header">
                    <div class="card-icon">
                        <i class="pi pi-inbox"></i>
                    </div>
                    <div class="card-badge">
                        <i class="pi pi-star-fill"></i>
                    </div>
                </div>
                <div class="card-content">
                    <h3 class="card-title">Revisar Solicitudes</h3>
                    <p class="card-description">Aprueba o rechaza solicitudes de EPP de los trabajadores</p>
                    <div class="card-stats">
                        <div class="stat-item">
                            <i class="pi pi-clock text-warning"></i>
                            <span>Pendientes</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- EPP Delivery -->
            <div class="admin-card" (click)="router.navigate(['epp/delivery/view'])">
                <div class="card-header">
                    <div class="card-icon">
                        <i class="pi pi-truck"></i>
                    </div>
                    <div class="card-badge">
                        <i class="pi pi-check-circle"></i>
                    </div>
                </div>
                <div class="card-content">
                    <h3 class="card-title">Entregar EPP</h3>
                    <p class="card-description">Gestiona la entrega de equipos aprobados</p>
                    <div class="card-stats">
                        <div class="stat-item">
                            <i class="pi pi-box text-success"></i>
                            <span>Para entregar</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- EPP Inventory -->
            <div class="admin-card" (click)="router.navigate(['/epp/inventory/list'])">
                <div class="card-header">
                    <div class="card-icon">
                        <i class="pi pi-box"></i>
                    </div>
                    <div class="card-badge">
                        <i class="pi pi-warehouse"></i>
                    </div>
                </div>
                <div class="card-content">
                    <h3 class="card-title">Inventarios</h3>
                    <p class="card-description">Gestiona el inventario de equipos de protección personal</p>
                    <div class="card-stats">
                        <div class="stat-item">
                            <i class="pi pi-box text-primary"></i>
                            <span>Inventario EPP</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Inspections Section -->
    <div class="inspections-section" *ngIf="isAdmin()">
        <div class="section-header">
            <h2 class="section-title">
                <i class="pi pi-clipboard text-primary mr-2"></i>
                Inspecciones de Campo
            </h2>
            <p class="section-description">Gestiona y revisa las inspecciones de seguridad</p>
        </div>
        
        <div class="inspections-grid">
            <div class="inspection-card" (click)="router.navigate(['/inspection/assign'])">
                <div class="inspection-main-content">
                    <div class="inspection-icon">
                        <i class="pi pi-calendar-plus text-primary"></i>
                    </div>
                    <div class="inspection-content">
                        <h4>Asignar Inspecciones</h4>
                        <p class="inspection-text">Crea y asigna nuevas inspecciones de campo</p>
                        <div class="inspection-features">
                            <span class="feature-tag">
                                <i class="pi pi-check-circle text-success mr-1"></i>
                                Plantillas disponibles
                    </span>
                        </div>
                    </div>
                </div>
                <div class="inspection-arrow">
                    <i class="pi pi-arrow-right"></i>
                </div>
            </div>

            <div class="inspection-card" (click)="router.navigate(['/inspection/templates'])">
                <div class="inspection-main-content">
                    <div class="inspection-icon">
                        <i class="pi pi-file-edit text-primary"></i>
                    </div>
                    <div class="inspection-content">
                        <h4>Gestionar Plantillas</h4>
                        <p class="inspection-text">Crea y edita plantillas de inspección</p>
                        <div class="inspection-features">
                            <span class="feature-tag">
                                <i class="pi pi-star text-warning mr-1"></i>
                                Personalizables
                    </span>
                        </div>
                    </div>
                </div>
                <div class="inspection-arrow">
                    <i class="pi pi-arrow-right"></i>
                </div>
            </div>
        </div>
    </div>

    <!-- Footer -->
    <div class="home-footer">
        <div class="footer-content">
            <p class="footer-text">
                © 2025 OSafety. Todos los derechos reservados.
            </p>
        </div>
    </div>
</div>